




















































































import { Component, PropSync, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { AtomTextField } from '@/components/atoms'
import { CollectionListStatus } from '@/types'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'

export interface CollectionListEditInfoItem {
  name: {
    input: string
    errorMessage: string
  }
  nameKana: {
    input: string
    errorMessage: string
  }
  status: {
    input: CollectionListStatus
  }
  releaseStartDate: {
    input: string
    errorMessage: string
  }
  releaseEndDate: {
    input: string
    errorMessage: string
  }
  unlimitedFlag: {
    input: boolean
  }
  priority: {
    input: string
    errorMessage: string
  }
  collectionNo: {
    input: string
    errorMessage: string
  }
  file: {
    name: string
    isUploading: boolean
  }
}

export const defaultCollectionListEditInfoItem = (): CollectionListEditInfoItem => ({
  name: {
    input: '',
    errorMessage: ''
  },
  nameKana: {
    input: '',
    errorMessage: ''
  },
  status: {
    input: CollectionListStatus.Private
  },
  releaseStartDate: {
    input: '',
    errorMessage: ''
  },
  releaseEndDate: {
    input: '',
    errorMessage: ''
  },
  unlimitedFlag: {
    input: false
  },
  priority: {
    input: '',
    errorMessage: ''
  },
  collectionNo: {
    input: '',
    errorMessage: ''
  },
  file: {
    name: '',
    isUploading: false
  }
})

@Component({
  components: { InputDatePicker }
})
export default class CollectionListEditInfo extends ComponentVue {
  @Ref()
  name!: AtomTextField

  @PropSync('infoItem', {
    type: Object,
    required: true
  })
  item!: CollectionListEditInfoItem

  get collectionListStatus(): any {
    return CollectionListStatus
  }

  get numberMask(): string {
    return '#'.repeat(9)
  }

  focusName(): void {
    this.name.atomTextField.focus()
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }
}
